<template>
  <v-div class="MonthSelector" mb-4>
    <v-div border-primary-thin-bottom title mb-1>{{ year }}</v-div>
    <v-div v-for="month in months" :key="month.no" d-inline-block>
      <nuxt-link
        v-if="month.inRange"
        :to="{ query: { period: month.isoDate } }"
      >
        <!-- class manipulation using v-cont-div classes needed for responsiveness of ui -->
        <v-div
          :class="
            month.isFocused
              ? 'font-weight-bold primary inverted--text'
              : undefined
          "
          pl-3
          pr-3
          pt-1
          pb-1
          >{{ month.name }}</v-div
        >
      </nuxt-link>
      <v-div v-else class="disabled-date" pa-3>{{ month.name }}</v-div>
    </v-div>
  </v-div>
</template>

<script>
import { parseISO, isWithinInterval } from "date-fns";

export default {
  name: "MonthSelector",
  props: {
    year: { type: Number, required: true },
    startDate: { type: String, required: true },
    period: { type: String, required: true },
  },
  data() {
    return {
      names: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
    };
  },
  computed: {
    months() {
      return this.names.map((name, index) => {
        const no = index + 1;
        const month = String("0" + no).slice(-2);
        const isoDate = `${this.year}-${month}`;

        const start = parseISO(this.startDate.substring(0, 7));
        const end = new Date();
        const current = parseISO(isoDate);

        const inRange = isWithinInterval(current, { start, end });

        const isFocused = isoDate === this.period;

        return { name, inRange, isFocused, isoDate };
      });
    },
  },
};
</script>

<style>
.MonthSelector {
  word-wrap: break-word;
}

.MonthSelector .disabled-date {
  opacity: 0.25;
}
</style>
